"use client";

import {
  IStoryBlokComponent,
  IStoryBlokCta,
  IStoryBlokImage,
} from "apps/website/components/page/api.types";
import { getStoryBlokImage } from "apps/website/utils/storyblok/image";
import { getStoryBlokCta } from "apps/website/utils/storyblok/links";

import SectionTrialOffer from "../../section/SectionTrialOffer/SectionTrialOffer";

export interface IStoryBlokTrialItem {
  _uid: string;
  id: string;
  label: string;
}

export interface IStoryBlokTrialOffer {
  _uid: string;
  component: "section_trial_offer";
  title: string;
  box_title: string;
  box_subtitle: string;
  trial_items: IStoryBlokTrialItem[];
  total_price: string;
  price_per_meal: string;
  image: IStoryBlokImage;
  cta: IStoryBlokCta[];
  footer_text?: string;
  show_sticky_cta?: boolean;
  sticky_cta_text?: string;
  section_id?: string;
  center_trial_items?: boolean;
}

export const StoryBlokTrialOffer = ({
  blok,
}: IStoryBlokComponent<IStoryBlokTrialOffer>) => {
  const cta = blok.cta?.[0];
  const ctaLink = cta ? getStoryBlokCta(cta) : null;

  return (
    <SectionTrialOffer
      title={blok.title}
      boxTitle={blok.box_title}
      boxSubtitle={blok.box_subtitle}
      trialItems={blok.trial_items?.map((item) => ({
        id: item.id,
        label: item.label,
      })) ?? []}
      totalPrice={blok.total_price}
      pricePerMeal={blok.price_per_meal}
      image={getStoryBlokImage(blok.image)}
      ctaText={cta?.name ?? "CLAIM MY TRIAL OFFER"}
      ctaHref={ctaLink?.to ?? "/sign-up/fresh"}
      footerText={blok.footer_text}
      showStickyCTA={blok.show_sticky_cta ?? false}
      stickyCTAText={blok.sticky_cta_text}
      id={blok.section_id}
      centerTrialItems={blok.center_trial_items ?? false}
    />
  );
};
